import {
    change_RhGraph,
    change_12Graph,
    change_ReprCmpxGraph,
    change_selectorGraph,
    change_SignalFilters,
    change_measurer_ECG12Graph,
    change_wholegraph,
    change_ReportSettings,
    fetch_RRHR_QTcAlg_Success,
    reset_graphSettings
} from "../../actions/actionConstants";
const getDefaultGraphSettings = () => {
    return {
        graphs: {
            graphRhythm: {
                timeScale_mm_s: 10,
                voltageScale_mm_mV: 5,
                channel: 0
            },
            graph12Leads: {
                start_pnt: undefined, // Определяет начальную точку графика, определяется областью для печати на графике прокрутки ЭКГ
                timeScale_mm_s: 25,
                voltageScale_mm_mV: 5
            },
            graphReprCmpx: {
                timeScale_mm_s: 50,
                voltageScale_mm_mV: 10,
                desiredCenter_pnt: null // Изначальная точка центра графика (чтобы при редактировании и открытии/закрытии периодов, сам график ЭКГ не менялся)
            },
            graphIntervalSelector: {
                timeScale_mm_s: 100,
                voltageScale_mm_mV: 25,
                desiredCenter_pnt: null, // Изначальная точка центра графика (чтобы при редактировании и открытии/закрытии периодов, сам график ЭКГ не менялся)
                channel: 1
            },
            wholeECGGraph: {
                timeScale_mm_s: 25,
                voltageScale_mm_mV: 10,
                xScaleIndex: 0,
                yScaleIndex: 0
            },
            wholeECGGraphRhythm: {
                timeScale_mm_s: 5,
                voltageScale_mm_mV: 5,
                channel: 0
            },

            measurerECG12Graph: {
                timeScale_mm_s: 50,
                voltageScale_mm_mV: 10,
                xScaleIndex: 2,
                yScaleIndex: 1
            },

            signalFilters: {
                baseline: true,
                _35Hz: false,
                _50Hz: false,
                spikes: false
            }
        }
    };
};
const updateGraphSettings = (state, action) => {
    if (state === undefined) {
        return getDefaultGraphSettings();
    }

    switch (action.type) {
        case reset_graphSettings: {
            return {
                ...state.reportData.settings,
                ...getDefaultGraphSettings()
            };
        }

        case change_ReportSettings:
            return {
                ...state.reportData.settings,
                ...action.payload,
                graphs: {
                    ...state.reportData.settings.graphs,
                    ...action.payload.graphs
                }
            };
        case fetch_RRHR_QTcAlg_Success: {
            const { QTcAlg, QTcAvailableAlgs } = action.payload;
            const ans = {
                ...state.reportData.settings
            };
            if (QTcAlg !== undefined && QTcAvailableAlgs !== undefined) {
                ans.QTcAlg = { val: QTcAlg };
                ans.QTcAvailableAlgs = { val: QTcAvailableAlgs };
            }
            return ans;
        }
        case change_RhGraph:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    graphRhythm: {
                        ...state.reportData.settings.graphs.graphRhythm,
                        ...action.payload
                    }
                }
            };
        case change_12Graph:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    graph12Leads: {
                        ...state.reportData.settings.graphs.graph12Leads,
                        ...action.payload
                    }
                }
            };
        case change_measurer_ECG12Graph:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    measurerECG12Graph: {
                        ...state.reportData.settings.graphs.measurerECG12Graph,
                        ...action.payload
                    }
                }
            };

        case change_wholegraph:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    wholeECGGraph: {
                        ...state.reportData.settings.graphs.wholeECGGraph,
                        ...action.payload
                    }
                }
            };

        case change_ReprCmpxGraph:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    graphReprCmpx: {
                        ...state.reportData.settings.graphs.graphReprCmpx,
                        ...action.payload
                    }
                }
            };
        case change_selectorGraph:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    graphIntervalSelector: {
                        ...state.reportData.settings.graphs.graphIntervalSelector,
                        ...action.payload
                    }
                }
            };
        case change_SignalFilters:
            return {
                ...state.reportData.settings,
                graphs: {
                    ...state.reportData.settings.graphs,

                    signalFilters: {
                        ...state.reportData.settings.graphs.signalFilters,
                        ...action.payload
                    }
                }
            };

        default:
            return state.reportData.settings;
    }
};

export default updateGraphSettings;
